import { render, staticRenderFns } from "./Mailout.vue?vue&type=template&id=3a2e22a7&"
import script from "./Mailout.vue?vue&type=script&lang=js&"
export * from "./Mailout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports